import { FileText } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { PageLayout } from '../../components/Layout/PageLayout';
import NewCadrageForm from '../../components/Cadrages/NewCadrageForm';

export default function NewCadragePage() {
  const { t } = useTranslation();
  return (
    <PageLayout
      icon={<FileText className="h-6 w-6" />}
      title={t('newCadrage.title')}
      subtitle={t('newCadrage.subtitle')}
    >
      <NewCadrageForm />
    </PageLayout>
  );
}
